// src/components/ui/SectionHeader.tsx
import React from "react";

type Props = { title: string; subtitle?: string };

export default function SectionHeader({ title, subtitle }: Props) {
    return (
        <div className="text-left mb-12">
            <h2 className="text-3xl font-bold text-gray-900">{title}</h2>
            {subtitle && <p className="mt-2 text-gray-600">{subtitle}</p>}
        </div>
    );
}
